export const WALLET_TYPE_NAME = {
  KZSHOP: '电商',
  KZCOMMUNITY: '社区',
  KZGIFTVOTE: '礼物投票',
  KZCOIN: '快币',
  KZMP: '小程序',
  PROMOCODE: '优惠码',
  WX_RED_PACKET: '红包钱包'
}